import { Report } from "src/Interfaces/TableInterfaces";
import {
  deleteRequest,
  getRequest,
  getTable,
  postRequest,
  putRequest,
} from "./requestTemplates";
import {
  IAddProfile,
  IBackTestSearchParams,
  IBorderConfig,
  IBorderTableReport,
  IDecileTE,
  INameIdFullName,
} from "src/Interfaces/deltaHedgeBackTest";
import { Packet } from "src/Interfaces/commonDtos";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { IMatrixChartResponse } from "src/Interfaces/chartInterfaces";
import { apiAddress } from "./config";
import { ChartData } from "src/Interfaces/automaticMarketMaking";

const controllerPath = "/v1/deltahedgeBacktest";

export const getProfileTable = (
  searchParam: any,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<any, any>(
    `${controllerPath}/ProfileTable`,
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getTimeConfigTable = (
  searchParam: any,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<any, any>(
    `${controllerPath}/TimeConfigTable`,
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getTETable = (
  searchParam: IBackTestSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IDecileTE>> =>
  getTable<any, any>(
    `${controllerPath}/DecileTETable`,
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getDEITable = (
  searchParam: any,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<any>> =>
  getTable<any, any>(
    `${controllerPath}/DecileDEITable`,
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const getBorderTable = (
  searchParam: any,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string
): Promise<Report<IBorderTableReport>> =>
  getTable<IBorderTableReport, any>(
    `${controllerPath}/TableBorderTable`,
    searchParam,
    offset,
    pageSize,
    sortingType
  );

export const addProfile = (formValues: IAddProfile): Promise<Packet<boolean>> =>
  postRequest(`${controllerPath}/addProfile`, formValues);

export const editProfile = (
  formValues: IAddProfile
): Promise<Packet<boolean>> =>
  postRequest(`${controllerPath}/editProfile`, formValues);

export const deleteProfile = (profileName: string): Promise<Packet<boolean>> =>
  deleteRequest(`${controllerPath}/deleteProfile?profileName=${profileName}`);

export const getProfiles = (): Promise<DropdownItem[]> =>
  getRequest(`${controllerPath}/getProfiles`);

export const getGroups = (): Promise<DropdownItem[]> =>
  getRequest(`${controllerPath}/getGroups`);

export const getMatrix = (
  profileId: string,
  groupId: string
): Promise<IMatrixChartResponse> => {
  // Create the base URL
  const url = new URL(
    `${
      apiAddress() ? apiAddress() : window.location.origin
    }${controllerPath}/Graph`
  );

  // Append query parameters if they exist
  if (profileId) url.searchParams.append("profileId", profileId);
  if (groupId) url.searchParams.append("groupId", groupId?.toString());

  const finalUrl = url.toString();

  return getRequest(finalUrl);
};

export const getDecileNos = (): Promise<INameIdFullName[]> =>
  getRequest(`${controllerPath}/GetDecileNos`);

export const getBorderConfig = (
  decileNo: string,
  profileId: string,
  groupId: string
): Promise<IBorderConfig> =>
  getRequest(
    `${controllerPath}/GetManualBorder?decileNo=${decileNo}&profileId=${profileId}&groupId=${groupId}`
  );

export const setBorderConfig = (
  config: IBorderConfig,
  decileNo: string,
  profileId: string,
  groupId: string
): Promise<Packet<boolean>> =>
  putRequest(
    `${controllerPath}/SetManualBorder?decileNo=${decileNo}&profileId=${profileId}&groupId=${groupId}`,
    config
  );

export const getBackTestGraph = (
  searchParam: IBackTestSearchParams
): Promise<ChartData> =>
  postRequest(`${controllerPath}/graph`, {
    ...searchParam,
  });
